import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";
import { ArrowLeft, Home, LockKeyhole } from "lucide-react";
import { Button } from "@/components/ui/button";

type ForbiddenSearch = {
  redirect?: string;
  required?: string;
};

export const Route = createFileRoute("/forbidden")({
  validateSearch: (search: Record<string, unknown>): ForbiddenSearch => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
    required: typeof search.required === "string" ? search.required : undefined,
  }),
  component: ForbiddenPage,
});

function ForbiddenPage() {
  const { required } = Route.useSearch();
  const navigate = useNavigate();
  const router = useRouter();

  return (
    <main className="min-h-svh flex items-center justify-center bg-muted/30 p-8">
      <div className="w-full max-w-md rounded-xl border bg-background p-10 text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-red-100 dark:bg-red-950">
          <LockKeyhole
            className="h-7 w-7 text-red-600 dark:text-red-400"
            aria-hidden="true"
          />
        </div>

        <p className="mb-2 text-lg font-medium text-foreground">
          Kein Zugriff auf diesen Bereich
        </p>

        <p className="mb-6 text-sm leading-relaxed text-muted-foreground">
          Für diese Seite fehlt dir die erforderliche Berechtigung. Wende dich
          an den Helpdesk, falls du Zugriff benötigst.
        </p>

        {required && (
          <div className="mb-7 inline-flex items-center gap-2 rounded-md bg-muted px-3 py-1.5">
            <span className="text-[13px] text-muted-foreground">
              Erforderliche Rolle
            </span>
            <span className="rounded-md bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800 dark:bg-red-950 dark:text-red-300">
              {required}
            </span>
          </div>
        )}

        <div className="flex gap-2.5">
          <Button
            variant="outline"
            className="flex-1 gap-2"
            onClick={() => router.history.back()}
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Zurück
          </Button>
          <Button
            className="flex-1 gap-2"
            onClick={() => navigate({ to: "/" })}
          >
            <Home className="h-4 w-4" aria-hidden="true" />
            Zur Startseite
          </Button>
        </div>
      </div>
    </main>
  );
}
